import {mapState} from 'vuex';
import moment from 'moment';

export default {
    data: () =>({
       now: moment(),
    }),
    computed: {
        ...mapState('setting', ['weekRanges']),
        schoolWeek() {
            const {weekRanges, now} = this;
            if (weekRanges && weekRanges.length > 0) {
                return (weekRanges.find(w => now.isBetween(w.begin, w.end, 'd', '[]')) || {week: -1})
                    .week;
            }

            return -1;
        },

        isEvenWeek(){
            return this.schoolWeek % 2 === 0;
        },

        isInNormalSemester(){
            return this.schoolWeek !== -1;
        },
    },
}